import NewsArticleStyleComponent from "./components/news-articles-style.component";
import NewsArticleComponent from "./components/news-articles.component";
import NewsArticlesLayoutComponent from "./components/news-articles-layout.component";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { retrieveArticleDetails, cleanArticleDetails } from "../../../redux/slice/article-details-slice";
import { RootState, useAppDispatch } from "../../../redux/store";
import ErrorBoundary from "../../errors/page-not-found";
import { useLocation } from "react-router-dom";

const NewsAndArticleDetails = () => {
  const location = useLocation();
  const pathName = location.pathname;
  const dispatch = useAppDispatch();
  const cachedNewsArticleComponent = useMemo(() => <NewsArticleComponent />, []);
  const { ArticleDetailsData: data, ArticleDetaislLoading: loading } = useSelector((state: RootState) => state.ArticleDetails);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    if (!loading) dispatch(retrieveArticleDetails(pathName));

    return () => {
      if (location.pathname.toLowerCase() !== window.location.pathname.toLowerCase()) {
        dispatch(cleanArticleDetails());
      }
    }
  }, [location]);

  if (!loading && data[0]?.statusCode === 404) {
    return <ErrorBoundary />
  }

  return (
    <>
    <style>
      {`
        @media(max-width: 767px){
          .subscribe-btn {
              margin-top: 25px;
          }
        }
      `}
    </style>
      <NewsArticleStyleComponent />
      <NewsArticlesLayoutComponent>
        {cachedNewsArticleComponent}
      </NewsArticlesLayoutComponent>
    </>
  );
};

export default NewsAndArticleDetails;
